import React from "react";
import { LogoutOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { initiateLogin } from "../../utils/common";
import { useDispatch } from "react-redux";
import type { AppDispatch } from "../../store";
import { logoutUser } from "../../redux/services/customerService";

const Logout: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>();

    const signOut = () => {
        dispatch(logoutUser()).then(() => {
            // Redirect to login page or initiate login
            initiateLogin();
        });
    };

    return (
        <div onClick={signOut} style={{ paddingRight: "10px", cursor: "pointer" }}>
            <div>
                <Tooltip color="blue" title="Logout">
                    <LogoutOutlined /> &nbsp; Logout
                </Tooltip>
            </div>
        </div>
    );
};

export default Logout;
